"use client";

import { RefreshCw } from "lucide-react";

interface DailyLoaderProps {
  readonly message?: string;
}

export default function DailyLoader({ message = "Loading today's challenge..." }: DailyLoaderProps) {
  return (
    <div style={{ textAlign: "center", padding: "3rem" }}>
      <h1 className="sr-only">Daily Finance Challenge</h1>
      <RefreshCw className="icon-spin" size={24} style={{ animation: "spin 1s linear infinite" }} />
      <p style={{ marginTop: "1rem" }}>{message}</p>
    </div>
  );
}
